import { makeVar } from '@apollo/client';

export const hasSellerVar = makeVar<boolean>(true);
